"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliveryStatus = void 0;
var DeliveryStatus;
(function (DeliveryStatus) {
    DeliveryStatus["ENVIANDO"] = "ENVIANDO";
    DeliveryStatus["ABIERTO"] = "ABIERTO";
    DeliveryStatus["RECHAZADO"] = "RECHAZADO";
    DeliveryStatus["SPAM"] = "SPAM";
    DeliveryStatus["RECIBIDO"] = "RECIBIDO";
    DeliveryStatus["SUPRIMIDO"] = "SUPRIMIDO";
    DeliveryStatus["INEXISTENTE"] = "INEXISTENTE";
    DeliveryStatus["BOUNCE"] = "BOUNCE";
})(DeliveryStatus || (exports.DeliveryStatus = DeliveryStatus = {}));
//# sourceMappingURL=delivery-status.js.map